export const recommendationQueryKeys = {
  all: ['recommendations'] as const,
  byId: (id: number) => ['recommendations', id] as const,
};
